import React from "react";

const FrequencyIcon = ({ fill = "#404040" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.069"
      height="12.986"
      viewBox="0 0 20.069 12.986"
    >
      <path
        id="db104"
        d="M174.659,251.247a.915.915,0,0,0,.668-.53L177.841,245l2.819,8.845a.915.915,0,0,0,.8.636h.066a.915.915,0,0,0,.821-.514l2.567-5.258H187.2a.914.914,0,0,0,0-1.829h-2.855a.915.915,0,0,0-.823.514l-1.817,3.726-2.853-8.989a.914.914,0,0,0-1.708-.091l-2.961,6.721L172,246.591a.914.914,0,0,0-.645-.265h-2.393a.914.914,0,1,0,0,1.829h2.016L173.845,251a.915.915,0,0,0,.814.249Z"
        transform="translate(-168.05 -241.496)"
        fill={fill}
      />
    </svg>
  );
};

export default FrequencyIcon;
